export default __webpack_public_path__ + "static/media/76-mobile.0aa341bc.jpg";